module.exports = __webpack_public_path__ + "img/04-3-2运维效率.be527af9.svg";